import styled from 'styled-components'
import { Button } from '@navent-jobs/ui-kit/components/button'

export const CustomButton = styled(Button)`
  padding: 0;
`

export const CouponContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 240px;
  height: 40px;
  margin-left: -14px;
`
